import { render, staticRenderFns } from "./AdditionalFieldTdMenu.vue?vue&type=template&id=5a44446a&scoped=true"
import script from "./AdditionalFieldTdMenu.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldTdMenu.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFieldTdMenu.vue?vue&type=style&index=0&id=5a44446a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44446a",
  null
  
)

export default component.exports